import { FiFileText, FiHelpCircle, FiInfo, FiPaperclip, FiSend } from "react-icons/fi";
import { MarketDialogueBlocker } from "../../autogen/bff-api";
import { defineWizardSteps } from "../../common/wizard/wizardSteps";

export type MarketDialogueStep = "basis" | "questions" | "documents" | "reachMarket" | "summary";

export const marketDialogueSteps = defineWizardSteps<MarketDialogueStep, boolean>(
  [
    { key: "basis", icon: FiInfo },
    { key: "questions", icon: FiHelpCircle },
    { key: "documents", icon: FiPaperclip },
    { key: "reachMarket", icon: FiSend },
    { key: "summary", icon: FiFileText },
  ],
  (_key, editable) => editable,
);

export const stepOfBlocker = (blocker: MarketDialogueBlocker): MarketDialogueStep | null => {
  switch (blocker) {
    case MarketDialogueBlocker.TitleMissing:
    case MarketDialogueBlocker.DescriptionMissing:
    case MarketDialogueBlocker.RegulationMissing:
    case MarketDialogueBlocker.ContractNatureMissing:
    case MarketDialogueBlocker.ServiceCategoryMissing:
    case MarketDialogueBlocker.EstimatedValueMissing:
    case MarketDialogueBlocker.CpvCodeMissing:
    case MarketDialogueBlocker.UtilityActivityMissing:
    case MarketDialogueBlocker.OutsideMarketDialogueScope:
      return "basis";
    case MarketDialogueBlocker.QuestionsMissing:
      return "questions";
    case MarketDialogueBlocker.AnswerDeadlineMissing:
    case MarketDialogueBlocker.AnswerDeadlinePassed:
    case MarketDialogueBlocker.ExpectedContractNoticeDateMissing:
    case MarketDialogueBlocker.ExpectedContractNoticeDateNotInFuture:
    case MarketDialogueBlocker.InvitationsMissing:
      return "reachMarket";
    case MarketDialogueBlocker.BuyerLegalTypeMissing:
    case MarketDialogueBlocker.BuyerLegalTypeTooGeneral:
    case MarketDialogueBlocker.BuyerOrganizationNumberMissing:
    case MarketDialogueBlocker.BuyerPostCodeMissing:
    case MarketDialogueBlocker.ContactPhoneMissing:
      return null;
  }
};
